function comColAddAdditionalFields(){
  $('.add-fields').on('click', function(e) {
    e.preventDefault();
    const $this = $(this);
    const dataNum = $this.attr('data-count');
    const dataType = $this.data('type');
    let template = $($('#fields-clone').html()).clone();
    
    template.find('label').text(dataType);
    template.find('input').each(function() {
      const $this = $(this);
      $this.attr('name', `properties[${dataType + ' ' + $this.attr('name') + dataNum}]`);
    })

    $this.attr('data-count', parseInt(dataNum) + 1);
    $this.parent().before(template);
    $('.cloned-fields').slideDown();
  })
}

export default comColAddAdditionalFields();



// WEBPACK FOOTER //
// ../markup/assets/js/com-col-add.js